export const WAREHOUSES_RECEIVED = "WAREHOUSES_RECEIVED";
export const RECEIVED_WAREHOUSES = "RECEIVED_WAREHOUSES";
export const UPDATE_WAREHOUSE = "UPDATE_WAREHOUSE";
export const CREATE_WAREHOUSE = "CREATE_WAREHOUSE";
export const GET_SINGLE_WAREHOUSE = "GET_SINGLE_WAREHOUSE";
export const DELETE_WAREHOUSE = "DELETE_WAREHOUSE";
export const SET_WAREHOUSE = "SET_WAREHOUSE";